import React, {useContext} from "react";
import Cancel from "./Cancel/Cancel.tsx";
import Save from "./Save/Save.tsx";
import Edit from "./Edit/Edit.tsx";
import Regenerate from "./Regenerate/Regenerate.tsx";
import UserAvatar from "./UserAvatar/UserAvatar.tsx";
import {MessageBottomContainerContext} from "../../Message.tsx";
import {useAppStore} from "../../../../../GlobalStore/GlobalStore.ts";
import ToggleState from "./ToggleState/ToggleState.tsx";
import OptionsMenu from "../Shared/OptionsMenu/OptionsMenu.tsx";
import Flag from "../Shared/Icons/Flag.tsx";
import {GlobalContext} from "../../../../../App.tsx";
import {toggleMessageImportance} from "../../../../../Utils/messageObject/messageObjectUtils.ts";
interface UserContainerProps {}

const UserContainer: React.FC<UserContainerProps> = () => {
    const { group } = useContext(MessageBottomContainerContext);
    const { setMessages } = useContext(GlobalContext);
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { editingId, importantMessageIds, conversationId } = dynamicStateObj;
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { isIncognito } = settingsObj;
    const userObj = useAppStore((state: any) => state.userObj);
    const { user } = userObj;
    const updateImportantMessageIds = useAppStore((state: any) => state.updateImportantMessageIds);

    const messageId = group.messages[0].id;
    const menuOptions = [
        {
            icon: <Flag color={"yellow"} />,
            label: "Important",
            onClick: () => {
                toggleMessageImportance(user, isIncognito, conversationId, messageId, !importantMessageIds.has(messageId), updateImportantMessageIds, setMessages);
            },
            tooltip: importantMessageIds.has(messageId) ? "Unmark message as important" : "Mark message as important"
        }
    ];

    const getUserElements = () => {
        if (editingId === group.index) {
            return (
                <div className="flex">
                    <Cancel/>
                    <Save/>
                </div>
            );
        } else {
            return (
                <div className="flex flex-col space-y-2.5">
                    {group.parentSelectedChild !== null && group.totalChildren !== null && group.totalChildren !== 1 && (
                        <ToggleState/>
                    )}
                    <div className="flex space-x-2.5 items-center">
                        <div className="flex items-center">
                            <div className="mr-2.5">
                                <OptionsMenu options={menuOptions} />
                            </div>
                            <Regenerate />
                            <Edit />
                        </div>
                        <UserAvatar timestamp={group.messages[0].metadata.timestamp} />
                    </div>
                </div>
            );
        }
    };

    return getUserElements();
};

export default UserContainer;